<template>
    <sub-frame title="转让方信息">
        <div slot="head">
            <mt-button icon="more" v-if="actions.length" type="primary" @click="sheetVisible=!sheetVisible"></mt-button>
        </div>
        <mt-actionsheet :actions="actions" v-model="sheetVisible"/>
        <template v-if="!editable">
            <mt-cell title="主体类型" :value="applicant.kind" />
            <mt-cell title="单位名称" :value="applicant.name"/>
            <mt-cell title="单位证件类型" :value="applicant.idType"/>
            <mt-cell title="单位证件号码" :value="applicant.idNum"/>
            <mt-cell title="法人姓名" :value="applicant.legalName"/>
            <mt-cell title="法人性别" :value="applicant.legalSex"/>
            <mt-cell title="法人生日" :value="applicant.legalBirthday"/>
            <mt-cell title="法人证件类型" :value="applicant.legalIdType"/>
            <mt-cell title="法人证件号码" :value="applicant.legalIdNum"/>
            <mt-cell title="法人人脸认证" :value="applicant.legalCertStatus" />
            <swipe-image :attachments="applicant.attachments"></swipe-image>
        </template>
        <template v-else>
            <mt-cell title="主体类型" :value="applicant.kind" />
            <mt-cell title="单位名称">
                <input type="text" v-model="applicantModified.name"/>
            </mt-cell>
            <mt-cell title="单位证件类型">
                <input type="text" v-model="applicantModified.idType"/>
            </mt-cell>
            <mt-cell title="单位证件号码">
                <input type="text" v-model="applicantModified.idNum"/>
            </mt-cell>
            <mt-cell title="法人姓名">
                <input type="text" v-model="applicantModified.legalName"/>
            </mt-cell>
            <mt-cell title="法人性别" :value="applicant.legalSex"/>
            <mt-cell title="法人生日" :value="applicant.legalBirthday"/>
            <mt-cell title="法人证件类型">
                <input type="text" v-model="applicantModified.legalIdType"/>
            </mt-cell>
            <mt-cell title="法人证件号码">
                <input type="text" v-model="applicantModified.legalIdNum"/>
            </mt-cell>
            <mt-cell title="法人人脸认证" :value="applicant.legalCertStatus" />
            <swipe-image :attachments="applicant.attachments"></swipe-image>
        </template>
    </sub-frame>
</template>

<script>
    export default {
        name: "CompanySeller",
        data() {
            return {
                applyGuid: this.$route.query.applyGuid,
                applicant: {
                    guid: this.$route.query.applicantGuid,
                    role: '',
                    kind: '',
                    name: '',
                    idType: '',
                    idNum: '',
                    legalGuid:'',
                    legalName: '',
                    legalSex: '',
                    legalBirthday: '',
                    legalIdType: '',
                    legalIdNum: '',
                    legalCertStatus: '',
                    legalSign: '',
                    unitSeal: '',
                    attachments: ''
                },
                applicantModified: null,
                sheetVisible: false,
                editable: false,
                actionsAll: [
                    {
                        name: '编辑修改',
                        method: () => this.editable = true
                    },
                    {
                        name: '保存修改',
                        method: this.saveApplicantInfo,
                    }
                ],
            }
        },
        computed: {
            actions() {
                if (this.$store.state.notaryRights.applicant_modify) {
                    return [this.actionsAll[this.editable ? 1 : 0]];
                } else {
                    return [];
                }
            }
        },
        created() {
            this.getApplicantInfo();
        },
        methods: {
            async getApplicantInfo() {
                let res = await this.$axios.get(`/applycheck/applyapplicant`,{
                    params: {
                        applicantGuid: this.applicant.guid,
                        applicantType: 'companyseller'
                    }
                });
                this.applicant = res.data;
                this.applicantModified = Object.assign({}, res.data);
            },
            async saveApplicantInfo() {
                await this.$axios.post(`/applycheck/applyapplicantmodify`, {
                    type: 'companyseller',
                    guid: this.applicantModified.guid,
                    name: this.applicantModified.name,
                    idType: this.applicantModified.idType,
                    idNum: this.applicantModified.idNum,
                    legalGuid: this.applicantModified.legalGuid,
                    legalIdType: this.applicantModified.legalIdType,
                    legalIdNum: this.applicantModified.legalIdNum,
                });
                this.$toast('修改成功');
                this.applicant = Object.assign({}, this.applicantModified);
                this.editable = false;
            }
        }
    }
</script>

<style scoped>

</style>